  import { Component, ElementRef, OnInit} from '@angular/core';
  import { NavigationEnd, NavigationStart, Router } from '@angular/router';
  import { CurrentLocationService } from './core/services/currentlocation.service';
  import { filter } from 'rxjs';
  import { CheckerService } from './core/services/checker.service';
  import { LocationService } from './core/services/location.service';
  import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
  import { MatDialog } from '@angular/material/dialog';
  import { NgxUiLoaderService } from 'ngx-ui-loader';
  import { StorageService } from './core/interceptor/storage.service';
  import { AuthService } from './core/services/auth.service';
  import { AllinoneService } from './core/services/allinone.service';
  import { CanonicalService } from './services/canonical.service';


  @Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
  })
  export class AppComponent implements OnInit{
    title = 'wanted_drivers_web';

    constructor(private router: Router,
       private locationTrack:CurrentLocationService, 
       private elementRef: ElementRef, 
       private middleware: CheckerService, 
       private locat:LocationService, 
       private breakpointObserver: BreakpointObserver, 
       private dialogRef: MatDialog, 
       private ngxLoader: NgxUiLoaderService, 
       private userService: AllinoneService, 
       private canonicalService: CanonicalService){}

    ngOnInit(): void {
    
      this.router.events.pipe(
        filter((event): event is NavigationStart => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => {
        this.ngxLoader.stopAll();
        this.closepopup();
        this.checkLocation();
        this.jqureymethods();
        window.scrollTo(0, 0);
    });
    
        this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        //  console.log('Navigation ended:', event.urlAfterRedirects);
        this.middleware.checkDetails();

        const canonicalUrl = `https://wanteddrivers.in${event.urlAfterRedirects}`;
        this.canonicalService.setCanonicalURL(canonicalUrl);

        if(event.url == '/home'){
          this.userService.setdynamicHeader(false);
        }
        else{
          this.userService.setdynamicHeader(true);
        }
      });
    }

    closepopup(){
      this.breakpointObserver
      .observe(['(width: 1024px)'])
      .subscribe((state: BreakpointState) => {
        //console.log(state)
        if (state.matches) {
          //console.log(state)
          this.dialogRef.closeAll();
        }
        else{
          this.dialogRef.closeAll();
        }
      });
    }

    jqureymethods() {
      var s2 = document.createElement("script");
      s2.type = "text/javascript";
      s2.src = "assets/js/theme2.js";
      this.elementRef?.nativeElement.appendChild(s2);
    }

    checkLocation(){
      if(localStorage.getItem('msgerror') == "User denied Geolocation" ||  localStorage.getItem('msgerror') == "Timeout expired" || localStorage.getItem('msgerror') == null || localStorage.getItem('msgerror') == undefined){
        this.locat.getCurrentPosition();
        this.locationTrack.getListLocation();
      }
    }
  }
